module.exports = __webpack_public_path__ + "static/assets/1a535cc1734f781095c20cefebff2539.png";